import styled from '@emotion/styled';
import { Children, ClassAttributes, createElement, ReactElement } from 'react';

import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import { Props as ItemProps } from './Item';
import ItemImpl from './ItemImpl';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
  children: ReactElement<ItemProps>[] | ReactElement<ItemProps>;
};

const Breadcrumbs = ({ className, children }: Props) => {
  const childrenLength = Children.count(children);
  const items = Children.toArray(children).map((child, index) => (
    <ItemImpl {...(child as ReactElement<ItemProps>).props} index={index} lastIndex={childrenLength - 1} key={index} />
  ));

  return <Root className={className}>{items}</Root>;
};

const Root = styled('div')(
  flexibleLayoutContainer({
    direction: 'row',
    alignItems: 'center',
    justifyItems: 'flex-start',
  }),
);

export default Breadcrumbs;
